import type { Dict } from "../en";

export const admin: Dict["admin"] = {
  // Shared by the admin pages.
  saveChanges: "Lưu thay đổi",
  name: "Tên",
  email: "Email",
  title: "Chức danh",
  archived: "Đã lưu trữ",
  newTag: "Mới",
  peopleCount_one: "{n} người",
  peopleCount_other: "{n} người",
  aboutTeam: "Giới thiệu nhóm",
  newTeamsHint: "Nhóm mới chỉ dùng bộ nhớ chung của công ty cho đến khi bạn cấp nguồn.",
  reachBy: "Liên hệ qua",
  reachWeb: "Web",
  reachEmail: "Email",
  reachBoth: "Cả hai",
  toolAccounts: "Tài khoản công cụ",
  deactivated: "Đã vô hiệu hóa",
  invitedNotSignedIn: "Đã mời, chưa đăng nhập",
  notNeeded: "không cần",

  // People.
  whatPeople: "danh sách thành viên",
  peopleSubtitle: "{people} và Vantage · Vantage đọc mọi hồ sơ ở mỗi lượt trả lời",
  setUpWithVantage: "Thiết lập cùng Vantage",
  setupAsk: "Thiết lập cho đồng đội mới: ",
  invite: "Mời",
  searchPeopleDots: "Tìm thành viên…",
  searchPeople: "Tìm thành viên",
  filterAll: "Tất cả",
  filterAdmins: "Quản trị viên",
  needsAttention: "Cần xử lý",
  colPersonAbout: "Thành viên · Giới thiệu",
  colStatus: "Trạng thái",
  vantageAbout: "Làm việc bằng tài khoản Redmine, GitHub và Outline của riêng mình.",
  vantageTitle: "Đồng đội AI · tài khoản quản trị",
  openDetails: "{name}, mở chi tiết",
  acctLinked: "đã liên kết",
  acctMissing: "thiếu",
  acctHeld: "chờ quản trị viên duyệt",
  acctNotCheckedYet: "chưa kiểm tra",

  // A person's panel.
  personDetails: "Chi tiết thành viên",
  newPerson: "Thành viên mới",
  person: "Thành viên",
  profile: "Hồ sơ",
  called: "Tên gọi",
  fullName: "Họ và tên",
  about: "Giới thiệu",
  aboutHelp:
    "Cả công ty đều thấy. Vantage đọc phần này ở mỗi lượt để chuyển câu hỏi và công việc đến đúng người.",
  language: "Ngôn ngữ",
  matchTheirMessage: "Theo ngôn ngữ tin nhắn của họ",
  teamsAndRole: "Nhóm và vai trò",
  removeFrom: "Gỡ khỏi {team}",
  addToTeam: "Thêm vào nhóm",
  inEveryTeam: "Đã ở trong mọi nhóm",
  role: "Vai trò",
  matchedBy: "khớp theo {by}",
  matchedEmail: "email",
  matchedName: "tên",
  matchedManual: "cách thủ công",
  noAccountFound: "không tìm thấy tài khoản",
  checkedWhenConnect: "sẽ kiểm tra khi kết nối công cụ (vòng 1)",
  linked: "Đã liên kết",
  missing: "Thiếu",
  notNeededLabel: "Không cần",
  notChecked: "Chưa kiểm tra",
  held: "Đang chờ duyệt",
  linkTo: "Liên kết {login}",
  addPerson: "Thêm thành viên",
  addedName: "Đã thêm {name}.",
  saved: "Đã lưu.",
  couldntSave: "Không lưu được.",
  activeAgain: "{name} đã hoạt động trở lại.",
  deactivate: "Vô hiệu hóa",
  deactivateTitle: "Vô hiệu hóa {name}?",
  deactivateBody:
    "Người này sẽ bị đăng xuất khỏi mọi nơi ngay lập tức và không đăng nhập được cho đến khi quản trị viên kích hoạt lại. Lịch sử của họ vẫn được giữ.",
  deactivatedName: "Đã vô hiệu hóa {name}",
  emailChangeTitle: "Đổi email của {name}?",
  emailChangeBody:
    "Người này sẽ bị đăng xuất khỏi mọi nơi, passkey và thông báo trên thiết bị của họ sẽ bị gỡ. Họ đăng nhập lại bằng {email}.",
  changeEmail: "Đổi email",
  reactivate: "Kích hoạt lại",

  // Teams.
  teamsSubtitle: "Mỗi nhóm có một kênh, bộ nhớ riêng và chỉ những nguồn bạn cấp",
  hideArchived: "Ẩn nhóm đã lưu trữ",
  showArchived: "Hiện nhóm đã lưu trữ",
  whatTeams: "danh sách nhóm",
  whatTheTeams: "danh sách nhóm",
  wholeCompany: "Cả công ty · {n} người",
  newTeam: "Nhóm mới",
  createTeam: "Tạo nhóm",
  createdTeam: "Đã tạo {team}. Tiếp theo, hãy cấp nguồn cho nhóm.",
  couldntCreateTeam: "Không tạo được nhóm.",
  syncToolFailed: "{tool} lỗi",
  withoutAccess: "{n} mục chưa được cấp quyền",
  synced: "Đã đồng bộ: {list}",
  syncFailed: "Đồng bộ không thành công. Hãy thử lại sau một phút.",
  syncing: "Đang đồng bộ…",
  syncNow: "Đồng bộ ngay",
  noAccessYet_one: "{n} mục chưa được cấp quyền truy cập:",
  noAccessYet_other: "{n} mục chưa được cấp quyền truy cập:",
  andMore: "và {n} mục khác",
  grantBelow: "Hãy cấp cho một nhóm bên dưới; các mục này được đánh dấu Mới.",

  // A team's editor.
  savedName: "Đã lưu {name}.",
  channelEveryone: "Kênh #everyone · cả công ty",
  channelSlug: "Kênh #{slug}",
  everyoneKeepsName: "Everyone là cả công ty nên giữ nguyên tên.",
  channelTakesName: "Kênh của nhóm cũng đổi theo tên mới.",
  aboutTeamHelp: "Vantage dựa vào phần này để biết một dữ kiện mới thuộc về nhóm nào.",
  listenIn: "Lắng nghe trong #{slug} để ghi vào bộ nhớ nhóm",
  listenHelp:
    'Thành viên sẽ thấy điều này ở đầu kênh. Tin nhắn bắt đầu bằng "off the record" sẽ được bỏ qua.',
  listenToggle: "Lắng nghe để ghi vào bộ nhớ nhóm",
  channelIcon: "Biểu tượng kênh",
  channelIconSub:
    "Hiện ở mọi nơi có nhóm: cạnh #{slug} trong danh sách Nhóm và ở đầu kênh, cùng trên các tác vụ tự động và thành viên của nhóm",
  // The channel icons' names (said lowercase; the tooltip capitalises them).
  iconCode: "mã nguồn",
  iconTerminal: "dòng lệnh",
  iconRocket: "tên lửa",
  iconFlask: "ống nghiệm",
  iconWrench: "cờ lê",
  iconShield: "khiên",
  iconChart: "biểu đồ",
  iconPalette: "bảng màu",
  iconCamera: "máy ảnh",
  iconHeart: "trái tim",
  iconBriefcase: "cặp tài liệu",
  iconUsers: "mọi người",
  iconMegaphone: "loa",
  iconCart: "giỏ hàng",
  iconGlobe: "quả địa cầu",
  iconBook: "sách",
  iconStar: "ngôi sao",
  iconCoffee: "cà phê",
  colour: "Màu",
  preview: "Xem trước",
  members: "Thành viên",
  everyActivePerson: "mọi người đang hoạt động",
  addPeople: "Thêm người",
  everyoneInTeam: "Mọi người đều đã ở trong nhóm này",
  removeName: "Gỡ {name}",
  noMembersYet: "Chưa có thành viên nào.",
  toolRedmine: "Dự án Redmine",
  toolGithub: "Repo GitHub",
  toolGithubSub: "trong bcsw",
  toolOutline: "Collection Outline",
  reachThroughVantage: "những gì {team} truy cập được qua Vantage",
  setAll: "Đặt tất cả",
  setAllOf: "Đặt tất cả {what}",
  everyCurrentItem: "Mọi mục hiện có",
  nothingUntilSync: "Chưa có gì: các mục sẽ hiện sau lần đồng bộ đầu tiên.",
  fenceMeta: "{id} · dùng cho kiểm thử tự động, được dọn sau mỗi lần chạy",
  adminPowers: "Quyền quản trị",
  adminPowersSub: "những việc quản trị {team} được nhờ Vantage làm",
  powerGithub: "Tạo repo và quản lý nhóm trên GitHub",
  powerGithubHint: '"Tạo repo cho dự án khách hàng mới"',
  powerRedmine: "Quản lý dự án và thành viên Redmine",
  powerRedmineHint: '"Thêm Linh vào dự án Family Tree"',
  powerOutline: "Quản lý collection Outline",
  powerOutlineHint: '"Tạo collection Outline cho tài liệu kế hoạch Q4"',
  powerPeople: "Thiết lập tài khoản cho thành viên",
  powerPeopleHint: "Thiết lập cho người mới trên Redmine, GitHub và Outline",
  powerAutomations: "Tạo tác vụ tự động cho nhóm này",
  powerAutomationsHint: "Bài đăng định kỳ và cảnh báo trong kênh của nhóm",
  // {a} is English only: the Vietnamese sentence has no article.
  memberExperiences: "Thành viên {team} sẽ thấy gì",
  everyoneExperiences: "Mọi người sẽ thấy gì",
  saveToUpdatePreview: "Hãy lưu để cập nhật bản xem trước.",
  accessLevels: "Mức truy cập",
  levelNoneHint: "nhóm này không thấy",
  levelReadHint: "xem và tìm kiếm",
  levelWriteHint: "tạo và cập nhật",
  levelManageHint: "thêm quyền xóa và thay đổi quản trị; Vantage luôn hỏi trước",
  backFromArchive:
    "{team} đã trở lại. Các tác vụ tự động của nhóm vẫn tạm dừng: hãy bật lại ở trang Tự động hóa.",
  archivedBody: "Kênh của nhóm đã trống và chỉ đọc, các tác vụ tự động đã tạm dừng.",
  openChannelReadOnly: "Mở kênh (chỉ đọc)",
  unarchiveTeam: "Bỏ lưu trữ nhóm",
  deleteTeam: "Xóa nhóm",
  deleteTitle: "Xóa vĩnh viễn #{slug}?",
  counting: "Đang đếm những gì sẽ bị xóa theo…",
  couldntCount: "Không đếm được những gì sẽ bị xóa theo.",
  erasedWithIt: "Sẽ bị xóa theo: {list}. Không thể hoàn tác.",
  nothingElse: "Không có gì khác bị xóa theo. Không thể hoàn tác.",
  typeNameToConfirm: "Nhập tên nhóm để xác nhận",
  deletedSlug: "Đã xóa #{slug}.",
  messagesCount_one: "{n} tin nhắn",
  messagesCount_other: "{n} tin nhắn",
  filesCount_one: "{n} tệp",
  filesCount_other: "{n} tệp",
  factsCount_one: "{n} dữ kiện",
  factsCount_other: "{n} dữ kiện",
  lessonsCount_one: "{n} bài học",
  lessonsCount_other: "{n} bài học",
  teamNotesCount_one: "{n} ghi chú nhóm",
  teamNotesCount_other: "{n} ghi chú nhóm",
  automationsCount_one: "{n} tác vụ tự động",
  automationsCount_other: "{n} tác vụ tự động",
  archiveTeam: "Lưu trữ nhóm",
  archiveTitle: "Lưu trữ {team}?",
  archiveBody:
    "#{slug} sẽ trống: thành viên không còn thấy kênh trong danh sách và Vantage ngừng lắng nghe ở đó. Lịch sử vẫn được giữ (quản trị viên vẫn đọc được), các tác vụ tự động sẽ tạm dừng. Bỏ lưu trữ sẽ đưa thành viên trở lại.",
  archivedName: "Đã lưu trữ {team}.",

  // Settings.
  whatSettings: "cài đặt",
  settingsSaved: "Đã lưu cài đặt.",
  settingsSubtitle: "Chi phí, mô hình và công tắc · mọi thay đổi đều có trong nhật ký thay đổi",
  capMonthly: "Mỗi tháng",
  capDaily: "Mỗi ngày",
  capPersonDaily: "Mỗi người mỗi ngày",
  capFastTurn: "Mỗi câu trả lời nhanh",
  capDeepTask: "Mỗi báo cáo phân tích sâu",
  fastAnswers: "Câu trả lời nhanh",
  fastAnswersHint: "hầu hết câu hỏi · suy luận có giới hạn",
  deepReports: "Báo cáo phân tích sâu",
  deepReportsHint: "lập kế hoạch, kiểm tra và viết báo cáo",
  sideTasks: "Tác vụ phụ",
  sideTasksHint: "tiêu đề, tóm tắt, sắp xếp bộ nhớ",
  vision: "Ảnh và PDF scan",
  visionHint: "đọc hình ảnh",
  searchIndex: "Chỉ mục tìm kiếm",
  searchIndexHint: "embedding (mô hình cục bộ)",
  memory: "Bộ nhớ",
  memoryHint: "Vantage lưu những gì học được và báo cho bạn, kèm nút Hoàn tác",
  listening: "Lắng nghe trong kênh nhóm",
  listeningHint: "Mỗi nhóm cũng có thể tắt ở trang Nhóm",
  automations: "Tự động hóa",
  automationsHint: "Bài đăng định kỳ và cảnh báo",
  memoryAndEmbeddings: "Bộ nhớ và embedding",
  titlesSummariesRouting: "Tiêu đề, tóm tắt và định tuyến",
  evals: "Đánh giá",
  senderDmarc: "Chỉ DMARC (nghiêm ngặt)",
  senderDmarcHelp:
    "Chỉ tin thư mà máy chủ của chúng ta đã kiểm tra và đạt DMARC; số còn lại chờ trong khu cách ly.",
  senderSubmission: "Tin cả thư đồng nghiệp gửi qua máy chủ thư của chúng ta",
  senderSubmissionHelp:
    "Tin cả thư đồng nghiệp gửi khi đã đăng nhập vào máy chủ thư của chúng ta, từ chính địa chỉ của họ.",
  ownMailbox: "Hộp thư riêng của Vantage",
  emailHelp:
    "Vantage trả lời thư của mọi người trong Vantage EX, gửi câu trả lời qua email khi được yêu cầu, chuyển lời, lời nhắc và bản tổng hợp. Khi tắt: chỉ còn thư đăng nhập được gửi đi.",
  senderCheck: "Kiểm tra người gửi",
  senderCheckHelp: "Ai được coi là đồng nghiệp khi có thư đến.",
  uploadLimit: "Giới hạn tải lên (MB)",
  previewPages: "Số trang xem trước",
  previewRows: "Số dòng xem trước mỗi trang tính",
  files: "Tệp",
  filesSub: "tải lên và trình xem trước",
  filesHelp:
    "Bản xem trước hiển thị những trang đầu của tệp và những dòng đầu của mỗi trang tính. Thay đổi chỉ áp dụng cho bản xem trước mới.",
  spend: "Chi phí",
  spendSub: "chi phí mô hình và embedding · tháng mới tính lại từ {date}",
  todayOf: "hôm nay, hạn mức {cap}",
  monthOf: "tháng này, hạn mức {cap}",
  topPersonToday: "dùng nhiều nhất hôm nay · {name}",
  noSpendToday: "hôm nay chưa ai phát sinh chi phí",
  avgFastAnswer: "trung bình mỗi câu trả lời nhanh",
  thisMonth: "Tháng này",
  capUsedAria: "Đã dùng {pct}% hạn mức tháng",
  pctOfCap: "{pct}% hạn mức",
  noSpendYet: "Tháng này chưa có chi phí nào.",
  calls_one: "{n} lượt gọi",
  calls_other: "{n} lượt gọi",
  backgroundWorker: "Tiến trình nền",
  mail: "Thư",
  toolSync: "Đồng bộ {tool}",
  toolNamed: "Công cụ: {name}",
  models: "Mô hình",
  healthOk: "Bình thường",
  healthDegraded: "Suy giảm",
  healthDown: "Ngừng hoạt động",
  on: "Bật",
  off: "Tắt",
  systemHealth: "Tình trạng hệ thống",
  checkedAt: "kiểm tra lúc {time}",
  version: "Phiên bản",
  commit: "commit {commit}",
  appAndDatabase: "Ứng dụng và cơ sở dữ liệu",
  checking: "Đang kiểm tra",
  lastChecked: "kiểm tra gần nhất lúc {time}",
  spendCaps: "Hạn mức chi phí",
  inUsd: "tính bằng đô la Mỹ",
  capsHelp:
    "Khi chạm hạn mức, các tác vụ tự động tạm dừng trước, câu hỏi mới được báo là đã hết hạn mức chi phí trong ngày (quản trị viên có thể nâng trong Cài đặt), và quản trị viên nhận được thông báo.",
  pricedModels: "{n} mô hình đã có giá",
  noPrices: "chưa ghi nhận giá nào",
  notChosen: "Chưa chọn",
  pricesHelp: "Giá cho mỗi triệu token là cơ sở cho mọi chi phí hiển thị trong Vantage.",
  switches: "Công tắc",
  switchesSub: "tắt hẳn một tính năng cho tất cả mọi người",
  company: "Công ty",
  timeZone: "Múi giờ",
  emailDomains: "Tên miền email công ty",
  domainsHelp: "Vantage chỉ mời những người có địa chỉ thuộc các tên miền này.",
  testMode: "Chế độ thử nghiệm",
  testModeOn: "Vantage chỉ có thể ghi vào dự án Test, collection Vantage Test và agent-sandbox.",
  testModeOff: "Vantage làm việc trên Redmine, GitHub và Outline thật, theo yêu cầu của mọi người.",
  testModeFenced:
    "Do máy chủ đặt, không chỉnh ở đây. Kiểm thử tự động luôn chạy trong vùng cách ly: chỉ có thể ghi vào dự án Test, collection Vantage Test và agent-sandbox.",
};
